"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.controlSizeTokens = void 0;
const GlobalDesignToken_1 = require("../../types/GlobalDesignToken");
const controlSizeS = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'control-size-s',
    fallback: '24px'
});
const controlSizeM = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'control-size-m',
    fallback: '32px'
});
const controlSizeL = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'control-size-l',
    fallback: '40px'
});
exports.controlSizeTokens = {
    controlSizeS,
    controlSizeM,
    controlSizeL
};
//# sourceMappingURL=ControlSize.js.map